import { Icon, IconProps } from "@chakra-ui/react";

const HelpIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.25C6.89137 3.25 2.75 7.39137 2.75 12.5C2.75 17.6086 6.89137 21.75 12 21.75C17.1086 21.75 21.25 17.6086 21.25 12.5C21.25 7.39137 17.1086 3.25 12 3.25ZM1.25 12.5C1.25 6.56294 6.06294 1.75 12 1.75C17.9371 1.75 22.75 6.56294 22.75 12.5C22.75 18.4371 17.9371 23.25 12 23.25C6.06294 23.25 1.25 18.4371 1.25 12.5Z"
      fill="#1819B4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8.25C11.3096 8.25 10.75 8.80964 10.75 9.5C10.75 9.91421 10.4142 10.25 10 10.25C9.58579 10.25 9.25 9.91421 9.25 9.5C9.25 7.98122 10.4812 6.75 12 6.75C13.5188 6.75 14.75 7.98122 14.75 9.5C14.75 10.0463 14.5899 10.5576 14.3138 10.9866C14.1409 11.2554 13.9387 11.5119 13.7523 11.7436C13.7182 11.786 13.6847 11.8275 13.6517 11.8683C13.4971 12.0597 13.3551 12.2354 13.2239 12.4158C12.9003 12.8605 12.75 13.1947 12.75 13.5V14C12.75 14.4142 12.4142 14.75 12 14.75C11.5858 14.75 11.25 14.4142 11.25 14V13.5C11.25 12.7007 11.6424 12.0398 12.011 11.5333C12.1667 11.3192 12.3373 11.1081 12.4925 10.9162C12.5236 10.8777 12.554 10.8401 12.5836 10.8033C12.7688 10.5731 12.9265 10.3706 13.0524 10.175C13.1774 9.98068 13.25 9.74996 13.25 9.5C13.25 8.80964 12.6904 8.25 12 8.25Z"
      fill="#1819B4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.992 17.5C10.992 16.9477 11.4397 16.5 11.992 16.5H12.001C12.5533 16.5 13.001 16.9477 13.001 17.5C13.001 18.0523 12.5533 18.5 12.001 18.5H11.992C11.4397 18.5 10.992 18.0523 10.992 17.5Z"
      fill="#1819B4"
    />
  </Icon>
);

export default HelpIcon;
